// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"dd2c2ecf","82":"1870b2c9","99":"b68ffe31","239":"22bdf6c6","349":"61601d05","375":"334c6bd1","442":"af245509","488":"fd72a599","715":"8a5626ed","813":"8a8834df","865":"cb49e7f5","878":"f1d7f014","963":"2e3ab3ad","988":"4d76881d"}[chunkId] + ".chunk.js";
};